module.exports = __webpack_public_path__ + "img/marker-gral-small.7e2d9fb9.png";